import React from 'react';
import { useTranslator } from 'tradera-lang/translate';
import { useFetchData } from 'tradera-hooks/use-fetch-data';
import { getShopDetails } from './profile-header/api';
import { LocalLoader } from 'tradera-components/loader/loader';

const ProfileInfo = ({ memberId }) => {
    const { t } = useTranslator();
    const { data, isLoading } = useFetchData(
        getShopDetails,
        memberId,
        'Profile Shop Info'
    );

    if (isLoading) {
        return (
            <div className="position-relative" style={{ minHeight: '270px' }}>
                <LocalLoader />
            </div>
        );
    }

    const { companyInfo, contactInfo, purchaseTerms } = data;

    const hasInfo = companyInfo || contactInfo || purchaseTerms;

    return (
        <div className="container">
            {hasInfo ? (
                <>
                    {companyInfo || purchaseTerms ? (
                        <>
                            <h2 className="text-styled">
                                {t('pageHeader_memberInfo')}
                            </h2>
                            <p
                                // eslint-disable-next-line react/no-danger
                                dangerouslySetInnerHTML={{
                                    __html: companyInfo
                                }}
                            />
                            <p
                                // eslint-disable-next-line react/no-danger
                                dangerouslySetInnerHTML={{
                                    __html: purchaseTerms
                                }}
                            />
                        </>
                    ) : null}
                    {contactInfo && (
                        <>
                            <h2 className="text-styled">
                                {t('pageHeader_memberContact')}
                            </h2>
                            <p
                                // eslint-disable-next-line react/no-danger
                                dangerouslySetInnerHTML={{
                                    __html: contactInfo
                                }}
                            />
                        </>
                    )}
                </>
            ) : (
                <h2 className="text-styled">
                    Säljaren har inte angett någon information
                </h2>
            )}
        </div>
    );
};

export { ProfileInfo };
